import type { SpecialtyOption, GroupKey } from './types'
import { GROUP_ORDER, groupLabel } from './groups'

export function specialtyLabel(s: SpecialtyOption, language: string): string {
  return language === 'uk' ? s.nameUk : s.nameEn
}

const norm = (s: string) => s.toLocaleLowerCase('uk').trim()

export function searchSpecialties(rows: SpecialtyOption[], query: string, language: string, exclude: string[] = []): SpecialtyOption[] {
  const ex = new Set(exclude)
  const base = rows.filter(r => !ex.has(r.id))
  const q = norm(query)
  if (!q) return base
  const scored = base.map(r => {
    const nameHay = [r.nameUk, r.nameEn, ...r.aliases].map(norm)
    const label = norm(specialtyLabel(r, language))
    // Group label matches only count as a whole-word hit (e.g. the query equals
    // "медсестри" from "Медсестри та акушерки"). A loose substring match against the
    // label would match every item sharing a group on any prefix of any label word
    // (e.g. "медсес" is a prefix of "медсестри"), pulling in unrelated specialties.
    const groupWords = norm(groupLabel(r.groupKey, language)).split(/\s+/)
    let score = 0
    if (label.startsWith(q)) score = 3
    else if (nameHay.some(h => h.startsWith(q))) score = 2
    else if (groupWords.includes(q)) score = 2
    else if (nameHay.some(h => h.includes(q))) score = 1
    return { r, score }
  }).filter(x => x.score > 0)
  // Tiebreak by original catalog position (the API returns rows in catalog order);
  // `sortOrderIndex` does not exist on SpecialtyOption.
  scored.sort((a, b) => b.score - a.score || base.indexOf(a.r) - base.indexOf(b.r))
  return scored.map(x => x.r)
}

export function groupSpecialties(rows: SpecialtyOption[], language: string) {
  const out: Array<{ key: GroupKey; label: string; items: SpecialtyOption[] }> = []
  for (const key of GROUP_ORDER) {
    const items = rows.filter(r => r.groupKey === key)
    if (items.length) out.push({ key, label: groupLabel(key, language), items })
  }
  return out
}
